const testimonialsSlider = {
    init: () => {
        if (window.innerWidth <= 767) {
            $('.lsg-testimonials__slides').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                centerMode: true, 
                centerPadding: '37px',
        });
        }
    }
}

export default testimonialsSlider;
